<template>
  <div>
    <the-headersider />

    <!-- Search & Actions -->
    <base-card class="toolbar">
      <input
        type="search"
        class="form-control"
        v-model="search"
        placeholder="Search by name, phone, estate, apartment or house no"
      />

     
<div class="row">
  <div class="col">
     <button class="btn btn-success" @click="downloadPDF">
          ⬇ Download Clients (PDF)
        </button>

  </div>
  <div class="col">
     <button class="btn btn-success" @click="downloadCSV">
          ⬇ Download Clients (CSV)
        </button>

  </div>
   <div class="toolbar-actions col">
        <router-link to="/register/clients" class="link btn btn-secondary">
          + Register Client
        </router-link>
  
</div>
       
      </div>
    </base-card>

    <!-- Clients Table -->
    <base-card>
      <div class="table-wrapper">
        <table class="table table-striped table-bordered fancy-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Phone</th>
              <th>Account</th>
              <th>Court</th>
                            <th>Monthly</th>

             
              <th>Arrears</th>
                            <th>Status</th>

                             <th>Reg date</th>

              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            <tr v-if="filteredClients.length === 0">
              <td colspan="10" class="empty">
                No clients found
              </td>
            </tr>

            <tr
              v-for="client in filteredClients"
              :key="client.id"
            >
              <td class="name">
                <router-link
                  :to="`/client/payments/${client.client_id}`"
                >
                  {{ client.name }}
                </router-link>
              </td>

              <td>{{ client.phone }}</td>
              <td>{{ client.client_id }}</td>
              <td>{{ client.court }}</td>
              
              <td>KES {{ client.montlyPayment }}</td>
              <td class="arrears">
                KES {{ client.arrears }}
              </td>

              <td>
                <span
                  class="status"
                  :class="client.isActive ? 'active' : 'inactive'"
                >
                  {{ client.isActive ? "Active" : "Inactive" }}
                </span>
              </td>

<td>{{ formatDate(client.reg_date) }}</td>

              <td>
                <router-link
                  :to="`/edit/client/${client.client_id}`"
                  class="edit"
                >
                  Edit
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </base-card>
  </div>
</template>

<script>
import jsPDF from "jspdf";
import "jspdf-autotable";

export default {
  data() {
    return {
      search: "",
    };
  },

  computed: {
    clients() {
      return this.$store.getters.clients;
    },

    filteredClients() {
      const key = this.search.toLowerCase();

      return this.clients.filter(client =>
        client.name.toLowerCase().includes(key) ||
        client.phone.toString().includes(key) ||
        client.client_id.toString().includes(key) ||
        (client.estate || "").toLowerCase().includes(key) ||
        (client.apartment || "").toLowerCase().includes(key) ||
        (client.houseNumber || "").toLowerCase().includes(key) ||
        (client.client_type || "").toLowerCase().includes(key)
      );
    },
  },

  created() {
    this.$store.dispatch("LoadClients");
  },

  methods: {

    formatDate(date) {
  const d = new Date(date);

  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
},
    downloadPDF() {
      const pdf = new jsPDF();

      const columns = [
        "Account",
        "Name",
        "Phone",
        "Court",
        "Arrears",
         "Reg Date",
        "Type"
      ];

      const rows = this.clients.map(c => [
                 c.client_id,

        c.name,
        c.phone,
        c.court,
    
        c.arrears,
                c.reg_date,

        c.client_type,

      
      ]);

      pdf.text("Cleanshift – Clients", 55, 20);
      pdf.line(0, 25, 210, 25);

      pdf.autoTable(columns, rows, {
        startY: 30,
        styles: { fontSize: 9 },
        headStyles: { fillColor: [40, 116, 240] },
      });

      pdf.save("All_Clients.pdf");
    },
    downloadCSV() {
  // Build timestamp: 2026-01-16_14-32
  const now = new Date();
  const timestamp = now.toISOString()
    .replace(/T/, "_")
    .replace(/:/g, "-")
    .split(".")[0];

  const headers = [
    "Account",
    "Name",
    "Phone",
    "Court",
   
    "Arrears",
        "reg Date",

    "Type"
  ];

  const rows = this.clients.map(c => [
    c.client_id,
     c.name,
    c.phone,
    c.court,
   
    c.arrears,
        c.reg_date,

    c.client_type
  ]);

const csvContent = [headers, ...rows]
  .map(row =>
    row
      .map(value =>
        `"${String(value !== null && value !== undefined ? value : "")
          .replace(/"/g, '""')}"`
      )
      .join(",")
  )
  .join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.setAttribute(
    "download",
    `All_Clients_${timestamp}.csv`
  );

  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
  URL.revokeObjectURL(url);
},


  },
};
</script>

<style scoped>
.toolbar {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  align-items: center;
}

.toolbar-actions {
  display: flex;
  gap: 1rem;
}

.form-control {
  width: 50%;
  padding: 0.6rem;
  border-radius: 8px;
  border: 1px solid #ccc;
}

.table-wrapper {
  overflow-x: auto;
}

.fancy-table thead th {
  position: sticky;
  top: 0;
  background: #f8fafc;
  z-index: 2;
}

.name a {
  font-weight: 600;
  color: #2563eb;
}

.name a:hover {
  text-decoration: underline;
}

.arrears {
  color: #dc2626;
  font-weight: 600;
}

.status {
  padding: 0.2rem 0.6rem;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 600;
}

.status.active {
  background: #dcfce7;
  color: #166534;
}

.status.inactive {
  background: #fee2e2;
  color: #991b1b;
}

.edit {
  color: #2563eb;
  font-weight: 600;
}

.empty {
  text-align: center;
  padding: 1rem;
}
</style>
